/**
 * @Description:
 * @author Shi_qshan
 * @date 2021/7/20
 */
import React from 'react'
import {ReactComponent as wX} from './wX.svg'
import Icon from '@ant-design/icons';

const IconWX = () => {
    return <Icon component={wX}></Icon>
};

export default IconWX